document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-banner__wrapper').forEach((wrapper) => {
    const video = wrapper.querySelector('.video-banner__video');
    const toggle = wrapper.querySelector('.video-banner__toggle');
    const poster = wrapper.querySelector('.video-banner__poster');
    if (!video || !toggle) return;

    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    if (poster) {
      poster.addEventListener('click', () => {
        video.play().catch(() => {});
        poster.classList.add('is-hidden');
      });
    }

    video.addEventListener('pause', () => toggle.classList.remove('is-playing'));
    video.addEventListener('play', () => {
      toggle.classList.add('is-playing');
      if (poster) poster.classList.add('is-hidden');
    });
  });
});
